<template>
    <v-app>
        <Toolbar title="Device Shipments"/>
        <v-content>
            <v-layout row>
                <v-flex xs12 sm12 offset-sm0>
                    <v-card>
                        <v-card-title primary-title>
                            <v-btn @click="$router.push({path: '/groups'})">
                                <v-icon dark>arrow_back</v-icon>
                            </v-btn>
                            <v-spacer></v-spacer>
                            <div>
                            </div>
                        </v-card-title>
                    </v-card>
                </v-flex>
            </v-layout>

            <v-card>
                <v-card-title primary-title>
                    <h3 class="headline mb-0">Completed Orders</h3>
                    <v-spacer></v-spacer>
                    <v-text-field
                            v-model="search"
                            append-icon="search"
                            label="Search"
                            single-line
                            hide-details
                    ></v-text-field>
                </v-card-title>

                <v-data-table
                        :pagination.sync="pagination"
                        :headers="orderHeaders"
                        :items="ordersForGroup"
                        :search="search"
                >
                    <template slot="items" slot-scope="props">
                        <td class="subheading">{{ dateFrom(props.item.updatedAt) }}</td>
                        <td class="subheading">{{ props.item.business }}</td>
                        <td class="subheading">{{ props.item.merchantId }}</td>
                        <td class="subheading">{{ props.item.terminalId }}</td>
                        <td class="subheading"><DeviceType v-bind:device-type="props.item.deviceType" /></td>
                        <td class="subheading">{{ props.item.serial }}</td>
                        <td class="subheading">{{ props.item.reference }}</td>
                        <td class="subheading">{{ props.item.shippingReference }}</td>
                        <td class="subheading"><v-btn flat icon color="indigo" @click="toShipping(props.item.id)">
                            <v-icon>local_shipping</v-icon>
                        </v-btn></td>
                    </template>
                    <v-alert slot="no-results" :value="true" color="error" icon="warning">
                        Your search for "{{ search }}" found no results.
                    </v-alert>
                </v-data-table>

            </v-card>

            <v-dialog v-model="deleteDialog" persistent max-width="290">
                <v-card>
                    <v-card-title class="headline">Return to Shipping?</v-card-title>
                    <v-card-text>Please confirm that you want to return this order to shipping. Note that this action cannot be
                        undone.
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1" flat @click.native="startReturnToShip">Yes, return</v-btn>
                        <v-btn color="green darken-1" flat @click.native="deleteDialog = false">No, cancel</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

        </v-content>
    </v-app>
</template>

<script>
    import {mapActions} from 'vuex'
    import Toolbar from '../components/Toolbar'
    import DeviceType from '../components/DeviceType'
    import Moment from 'moment'

    const fb = require('../firebase')

    export default {
        name: "Orders",
        components: {Toolbar, DeviceType},
        data() {
            return {
                search: '',
                pagination: {'sortBy': 'updatedAt', 'descending': true, 'rowsPerPage': 50},
                rowsPerPage: [50, 100, 250, {'text': '$vuetify.dataIterator.rowsPerPageAll', 'value': -1}],
                orderHeaders: [
                    {text: 'Updated', align: 'left', sortable: true, value: 'updatedAt'},
                    {text: 'Business', align: 'left', sortable: true, value: 'business'},
                    {text: 'Merchant ID', align: 'left', sortable: true, value: 'merchantId'},
                    {text: 'Terminal ID', align: 'left', sortable: true, value: 'terminalId'},
                    {text: 'Device', align: 'left', sortable: true, value: 'deviceType'},
                    {text: 'Serial', align: 'left', sortable: true, value: 'serial'},
                    {text: 'Sales Ref', align: 'left', sortable: true, value: 'reference'},
                    {text: 'Shipping Ref', align: 'left', sortable: true, value: 'shippingReference'},
                    {text: 'Return to Shipping', align: 'left', sortable: false}
                ],
                ordersForGroup: [],
                newOrderName: '',
                deleteDialog: false,
                toShippingId: ''
            }
        },
        mounted() {
            if (!this.isUserLoggedIn()) {
                this.$router.push({path: '/signin'})
            }
            // this.fetchAll()
            this.fetchShipments()
        },
        methods: {
            ...mapActions(['isUserLoggedIn', 'fetchAll']),
            routeLink: function (val) {
                this.$router.push('/shipment/' + val)
            },
            upperCaseFirst: function (val) {
                return val.charAt(0).toUpperCase() + val.substr(1)
            },
            dateFrom: function (dt) {
                return Moment.unix(dt).fromNow()
            },
            fetchShipments: function () {
                this.$store.commit('showProgress')
                let that = this
                fb.formsCollection
                    .where('status', '==', 'complete')
                    .orderBy('updatedAt', 'desc')
                    .limit(200)
                    .get()
                    .then(function(forms) {
                        that.$store.commit('hideProgress')
                        that.ordersForGroup = []
                        forms.forEach((form) => {
                            let f = form.data()
                            if (f['updatedAt']===undefined) {
                                f['updatedAt'] = Math.floor(Date.now() / 1000)
                            } else {
                                f['updatedAt'] = Math.floor(f['updatedAt'].seconds)
                            }
                            f['id'] = form.id
                            that.ordersForGroup.push(f)
                        })
                    })

            },
            toShipping: function (id) {
                this.toShippingId = id
                this.deleteDialog = true
            },
            startReturnToShip: function () {
                fb.formsCollection.doc(this.toShippingId).update({
                    status: 'ship'
                })
                    .then(() => {
                        this.toShippingId = ''
                        this.deleteDialog = false
                        this.$store.commit('showSnack', 'Order returned to shipping')
                        this.fetchShipments()
                    })
            }
        }
    }
</script>

<style scoped>

</style>
